<script lang="ts">
	import { _ } from 'svelte-i18n';
	import TextArea from '$lib/components/Inputs/TextArea.svelte';

	export let prompt: string;
	export let disabled = false;
</script>

<div class="prompt-section">
	<TextArea
		bind:value={prompt}
		fullWidth
		name="prompt"
		{disabled}
		placeholder={$_('hubs.copywriter.prompt.placeholder')}
		rows={6} />
</div>
